import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const CTASection = ({ onOpenContactForm, heading, buttonText, variant = 'purple' }) => {
  const section = useScrollAnimation({ threshold: 0.2 });
  const isPurple = variant === 'purple';

  return (
    <section data-testid="cta-section" ref={section.ref} className="relative overflow-hidden" style={{
      background: isPurple
        ? 'linear-gradient(135deg, #1a0a2e 0%, #4C1D95 50%, #7C3AED 100%)'
        : 'linear-gradient(135deg, #064E3B 0%, #0D9488 50%, #14B8A6 100%)'
    }}>
      <div className="absolute inset-0 overflow-hidden">
        <div className={`absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full blur-[100px] ${isPurple ? 'bg-[#14B8A6]/15' : 'bg-[#7C3AED]/15'}`} />
        <div className={`absolute -bottom-20 -left-20 w-[300px] h-[300px] rounded-full blur-[80px] ${isPurple ? 'bg-[#7C3AED]/20' : 'bg-[#14B8A6]/20'}`} />
      </div>

      <div className="mx-auto w-full max-w-7xl px-4 md:px-8 py-24 md:py-28 relative z-10">
        <div className={`max-w-3xl mx-auto text-center scroll-fade-up ${section.isVisible ? 'scroll-visible' : ''}`}>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white leading-[1.1] mb-8" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            {heading}
          </h2>
          <Button
            data-testid="cta-section-button"
            onClick={onOpenContactForm}
            className={`font-semibold px-10 h-13 text-base rounded-full active:scale-[0.97] shadow-lg ${
              isPurple ? 'bg-[#14B8A6] hover:bg-[#0D9488] text-white shadow-teal-500/25' : 'bg-white text-zinc-900 hover:bg-zinc-100 shadow-white/25'
            }`}
          >
            {buttonText}
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
